<script>
  import Header from "./components/Header.svelte";
  import Footer from "./components/Footer.svelte";
  import Productos from "./components/Productos.svelte";
  import Nosotros from "./components/Nosotros.svelte";
  import ContactCard from "./components/Card.svelte";
  import Asesoria from "./components/Asesoria.svelte";
</script>
<h1 hidden>Ice Ma - Geles Refrigerantes</h1>
<main>
    <div class="background">
      <Header />


      <div class="container">
        <div class="container-margin" id="productos">
          <Productos />
        </div>
        <div id="asesoria">
          <Asesoria />
        </div> 
        <div id="contacto">
                  <ContactCard/>
        </div>
      </div>
      <!-- <div id="nosotros">
        <Nosotros />
      </div> -->
      <Footer/>
    </div>


</main>
<style>
  /* #nosotros{
    overflow: hidden;
  } */

</style>